import Vue from 'vue'
import VueLocalforage from 'v-localforage'

Vue.use(VueLocalforage, {"name":"promotionbasis","storeName":"cache"})

export default (ctx, inject) => {
  inject('localForage', Vue.$localforage)
}
